import type { ReactNode } from "react";

import { AudioControlsContext, type AudioControlsContextValue } from "../context/audio-controls-context";

export const AudioControlsProvider = ({
  value,
  children,
}: {
  value: AudioControlsContextValue;
  children: ReactNode;
}) => {
  return <AudioControlsContext.Provider value={value}>{children}</AudioControlsContext.Provider>;
};
